import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { thresholdUpdate } from '../../../redux/actions/thresholds';

const UpdateThresholdModal = ({ payload, showUpdateThresholdModal, setShowUpdateThresholdModal, threshold, thresholdName, updateThreshold, settings, accountUnits, modalY }) => {
  const [lowInventory, setLowInventory] = useState(null);
  const [criticalInventory, setCriticalInventory] = useState(null);
  const [targetInventory, setTargetInventory] = useState(null);

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  const clearAndClose = () => {
    setLowInventory(null);
    setCriticalInventory(null);
    setTargetInventory(null);
    setShowUpdateThresholdModal(false);
  }

  // const format = (value) => {
  //   return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  // }

  const update = () => {
    let thresholdValues = { lowInventory: lowInventory, criticalInventory: criticalInventory, targetInventory: targetInventory };

    updateThreshold(payload, threshold, thresholdValues);
    clearAndClose();
  }

  const validateQuantity = (event, setField) => {
    let value = event.target.value;
    setField(value.replace(/[^\d.-]+/g, '') || 0.0);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const validateInteger = (event, setField) => {
    let value = parseInt(event.target.value).toString();
    setField(value || 0);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const validateValue = (event, setField) => {
    let value = event.target.value;
    setField(value);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  return(
    <div className="main-overlay">
      <div style={{ top: `${modalY}px`, transform: 'translate(0%, -50%)', position: 'fixed' }} className="main-popup main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => clearAndClose()}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            <h3 className="main-popup__title">
              <span className="gwt-InlineHTML">Update Thresholds</span>
            </h3>
            <div className="main-popup__text" aria-hidden="true" style={{display: 'none'}}></div>
            <div className="main-popup__content">
              <h4>{thresholdName}</h4>

              Curent Target Inventory: {threshold?.target_inventory}<br/>
              Curent Low Inventory: {threshold?.low_inventory}<br/>
              Curent Critical Inventory: {threshold?.critical_inventory}

              <hr/>

              <div className="fieldset">
                <div className="field field--medium">
                  <span className="fieldset__svg-icon"></span>
                  <label className="field__label">Update Target Inventory</label>
                  <input onFocus={focus} onBlur={blur} tabindex="4" maxlength="64" className="field__input" id="update_supplier_sku" type="text" value={targetInventory} onChange={(e) => validateValue(e, setTargetInventory)} />
                  <div className="field__placeholder">Update Target Inventory</div>
                </div>


                <div className="field field--medium">
                  <span className="fieldset__svg-icon"></span>
                  <label className="field__label">Update Low Inventory</label>
                  <input onFocus={focus} onBlur={blur} tabindex="4" maxlength="64" className="field__input" id="update_supplier_price" min="0" type="number" value={lowInventory} onChange={(e) => validateQuantity(e, setLowInventory)} />
                  <div className="field__placeholder">Update Low Inventory</div>
                </div>


                <div className="field field--medium">
                  <span className="fieldset__svg-icon"></span>
                  <label className="field__label">Update Critical Inventory</label>
                  <input onFocus={focus} onBlur={blur} tabindex="4" maxlength="64" className="field__input" id="update_minimum_quantity" step="1" min="0" type="number" value={criticalInventory} onChange={(e) => validateInteger(e, setCriticalInventory)} />
                  <div className="field__placeholder">Update Critical Inventory</div>
                </div>
              </div>

            </div>
            <div className="main-popup__buttons">
              <button type="button" className="btn btn-default btn-medium" tabindex="1000" onClick={() => clearAndClose()}>
                Cancel
              </button>
              <button type="button" className="btn btn-primary btn-medium" tabindex="1000" onClick={() => update()}>
                Update Thresholds
              </button>
            </div>
            <div className="main-popup__footer-text" aria-hidden="true" style={{display: 'none'}}></div>
          </div>
        </div>
      </div>
    </div>

  )
}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  settings: state.settings
});

const mapDispatchToProps = (dispatch) => ({
  updateThreshold: (payload, threshold, thresholdValues) => dispatch(thresholdUpdate(payload, threshold, thresholdValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateThresholdModal);
